import * as config from './commons/config';
import { featureFlagsService } from './commons/featureFlagsService';
import { getLogger } from './commons/logger';
import type { OptionValues } from 'commander';

const logger = getLogger('runOptionsUtils');

export function getExtensionsUrl(program: OptionValues) {
    const zipFileSuffix = program.canary ? '-master.zip' : '.zip';
    let chrome = `${config.EXTENSION_SP_S3_HOST}/testim-headless${zipFileSuffix}`;
    let testimHeadlessExtensionDownloadUrl = featureFlagsService.flags.testimHeadlessExtensionDownloadUrl.getValue({
        companyId: program.company?.companyId,
        projectId: program.project,
        runnerEnvironment: config.RUNNER_ENVIRONMENT,
    });

    // This is for debugging purposes, if the flags returns nothing, we will default to MV3 extension.
    if (!testimHeadlessExtensionDownloadUrl) {
        logger.warn('testimHeadlessExtensionDownloadUrl flag is not set, defaulting to MV3 extension', {
            resultId: program.resultId,
            executionId: program.executionId,
            projectId: program.project,
        });
        testimHeadlessExtensionDownloadUrl = `${config.EXTENSION_SP_S3_HOST}/testim-headless.zip`;
    }

    const isExtensionPassedAsArg = program.ext || program.extensionPath;

    if (!isExtensionPassedAsArg && testimHeadlessExtensionDownloadUrl) {
        chrome = testimHeadlessExtensionDownloadUrl;
        program.testimHeadlessExtensionDownloadUrl = testimHeadlessExtensionDownloadUrl;
    }

    return {
        chrome,
        'edge-chromium': chrome,
    };
}

export function getResolvedExtensionUrl(program: OptionValues) {
    const { chrome } = getExtensionsUrl(program);
    return chrome;
}

export function getPlayerUrl(program: OptionValues) {
    const playerUrlPrefix = `${config.EXTENSION_SP_S3_HOST}/sessionPlayer`;
    const playerUrl = program.canary ? `${playerUrlPrefix}-master` : playerUrlPrefix;

    return playerUrl;
}
